import axios from "axios";
import API from "../helpers/api";
import FileSaver from 'file-saver';

let user = JSON.parse(localStorage.getItem("currentUser"));
export const getCalibrationShipCount = (searchItem) => {
   
    let url = `${API.GetShipCount}?shipId=${searchItem.shipId}&clientId=${searchItem.clientId}&email=${user.email}`;
    return (dispatch) => {
      axios
        .get(url)
        .then((response) => {
          dispatch({
            type: "GetCalibrationShipCountSuccess",
            data: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: "GetCalibrationShipCountFailure",
            error: "ERROR",
          });
        });
    };
  };

  export const getClientShipDetails = (Item) => {
   
    let url = `${API.GetClientShipDetails}?shipId=${Item ?? 0}`;
    return (dispatch) => {
      axios
        .get(url)
        .then((response) => {
          dispatch({
            type: "GetClientShipDetailsSuccess",
            data: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: "GetClientShipDetailsFailure",
            error: "ERROR",
          });
        });
    };
  };



export const DownloadDocument = (filename, guid) => {
    let url = `${API.DownloadAttachmentAPI}?filename=${btoa(filename)}&guidValue=${guid}`;
    return dispatch => {
        axios.get(url, { responseType: "blob" })
            .then((response) => {
                let blob = '';
                blob = new Blob([response.data], { type: response.data.type });
                FileSaver.saveAs(blob, filename);
            })
            .catch((error) => {
                console.log(error);
                dispatch({
                    type: "AttchmentDownloadFailure",
                    error: "ERROR"
                })
            })
    }
}


